import script from "./ProfileChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ProfileChangePassword.vue?vue&type=style&index=0&id=3bd40830&lang=css"

const __exports__ = script;

export default __exports__